import { Tr, Td, Icon, Row, Col } from "@visa/vds"
import { VSTT_TITLE, LINK_TYPE, DASHBOARD_STAFF_VSTT_SUBSCRIPTION_TABLE_HEADERS, DASHBOARD_USER_VSTT_SUBSCRIPTION_TABLE_HEADERS, getCardAlertType, renderSubtitle, VSTT_SUBTITLES } from "_constants/DashboardConstants"
import React, { useContext, useEffect, useState } from "react"
import DashboardAccordion from "../DashboardAccordion"
import VsttAccordionActionItems from "./VsttAccordionActionItems"
import { useAuthContextUser } from "context/AuthContext"
import MCSPagedTable from "components/MCSPagedTable"
import { DashboardUserApi, DashboardStaffApi } from "services/dashboard.service"
import { trackPromise } from "react-promise-tracker"
import { GlobalAlertContext } from "context/GlobalAlertContext";
import { LibraryPostFileClickAction } from "_constants/GlobalConstants"
import { LibraryPostType } from "_constants/LibraryConstants"
import { LibraryHelper } from "_helpers/LibraryHelper"
import MCSConfirmDialog from "components/MCSConfirmDialog"

const PAGE_SIZE = 10

const VsttSubscriptionsAccordion = (props) => {
    let {
        selectedBid,
        setPageError,
    } = props

    const alertContext = useContext(GlobalAlertContext);
    const user = useAuthContextUser();

    const isExternalUser = user && user.isExternalUser;
    const vsttTableHeaders = isExternalUser ? DASHBOARD_USER_VSTT_SUBSCRIPTION_TABLE_HEADERS : DASHBOARD_STAFF_VSTT_SUBSCRIPTION_TABLE_HEADERS
    const API = isExternalUser ? DashboardUserApi : DashboardStaffApi

    const [vsttSubscriptions, setVsttSubscriptions] = useState(null);
    const [confirmDialog, setConfirmDialog] = useState(null);
    const [subtitle, setSubtitle] = useState(null)
    const [tableState, setTableState] = useState({
        totalCount: 0,
    })

    let toggleVsttRowButton = (idx) => {
        let subscriptions = [...vsttSubscriptions]
        subscriptions[idx].expanded = !subscriptions[idx].expanded
        setVsttSubscriptions(subscriptions)
    }

    let updateTableState = (totalCount) => {
        let newTableState = { ...tableState }
        newTableState.totalCount = totalCount
        setTableState(newTableState)
    }


    const fetchData = () => {
        trackPromise(
            API.getVsttSubscriptions(selectedBid)
                .then((result) => {
                    setVsttSubscriptions(result.data.items.map((item) => { return { ...item, expanded: false } }))
                    updateTableState(result.data.totalCount)
                    setSubtitle(renderSubtitle(result.data.items, getCardAlertType(result.data.dashboardExpirationAlert), VSTT_SUBTITLES))
                })
                .catch((error) => {
                    setPageError(error);
                    alertContext.setGlobalErrorMessage(error.message);
                })
        );
    };

    let handleVsttLibraryPostObject = (type, postId, notice) => {
        let data = {
            postId: postId,
            postType: type,
            action: type === LibraryPostType.File ? LibraryPostFileClickAction.Open : LibraryPostFileClickAction.Link
        }
        notice ? LibraryHelper.openLibraryNoticeDialog(setConfirmDialog, confirmDialog, notice, data) : LibraryHelper.handleLibraryPostOnClick(data)
    }

    useEffect(() => {
        fetchData();
    }, [selectedBid]);


    return (
        <>
            <Row>
                <Col>
                    <DashboardAccordion id="dashboard-vstt-subscription-accordion"
                        accordionHeaderActionComponent={<VsttAccordionActionItems />}
                        subtitle={subtitle}
                        title={VSTT_TITLE}
                    ><>
                            <Row className="vstt-subscriptions-table">
                                <MCSPagedTable
                                    size={"compact"}
                                    colHeaders={vsttTableHeaders}
                                    selectedPage={1}
                                    totalPages={1}
                                    pageSize={PAGE_SIZE}
                                    totalCount={tableState.totalCount}
                                    usePagination={true}
                                    tableData={
                                        vsttSubscriptions && vsttSubscriptions.map((row, key) =>

                                            <>
                                                <Tr className={`${key % 2 === 1 ? "row-vstt-odd" : "row-vstt-even"} vstt-product`} key={key}>
                                                    <Td className="cursor-pointer" onClick={() => toggleVsttRowButton(key)} id={row.name}>
                                                        <Icon

                                                            name={`arrow-${row.expanded ? "collapse" : "expand"}`}
                                                            className="icon-vsts"
                                                            resolution="tiny"
                                                            aria-label="arrow-next" />{row.name}
                                                    </Td>
                                                    <Td id={row.name + " " + row.subscriptionType}>{row.subscriptionType}</Td>

                                                </Tr>
                                                {row.expanded && row.libraryPosts && row.libraryPosts.map((s, k) => {
                                                    let linkType = s.type === LINK_TYPE.URL ? "link" : "document-pdf"
                                                    return (
                                                        <Tr className={key % 2 === 1 ? "row-vstt-odd" : "row-vstt-even"} key={k}>
                                                            <Td className="vstt-subscription">
                                                                <Icon className="icon-vsts" name={linkType} resolution="low" aria-label={linkType} />
                                                                <a onClick={() => handleVsttLibraryPostObject(s.type, s.postId, s.notice)}
                                                                    className="cursor-pointer text-decoration-none vertical-align-super">{s.title}</a>
                                                            </Td>
                                                            <Td />
                                                        </Tr>
                                                    )
                                                })}
                                            </>
                                        )
                                    }
                                />
                            </Row>
                            {confirmDialog && (
                                <MCSConfirmDialog
                                    confirmHandler={LibraryHelper.handleLibraryPostOnClick}
                                    confirmDialog={confirmDialog}
                                    setConfirmDialog={setConfirmDialog}
                                />
                            )}
                        </></DashboardAccordion>
                </Col>
            </Row>
        </>
    )
}

export default VsttSubscriptionsAccordion